import { NewPartnerAgreement } from "src/entities/partnerContracts/ui/components/agreements/NewPartnerAgreement";

export function CreatePartnerAgreementPage() {
  return <NewPartnerAgreement />;
}
